import { logException } from "@classdojo/log-client";
import type { JSONObject } from "./types";

/**
 * Parses a `data-event-metadata` attribute value (as written by `EventMetadata`).
 * Returns `{}` and reports via telemetry instead of throwing if the value is
 * missing or malformed, since this typically runs in DOM-read paths (event
 * logging, mutation observers) where a bad attribute shouldn't break the caller.
 */
export function parseEventMetadataAttr(raw: string | undefined): JSONObject {
  if (!raw) return {};
  try {
    return JSON.parse(raw) as JSONObject;
    // eslint-disable-next-line no-catch-all/no-catch-all -- JSON.parse only throws SyntaxError for malformed data-event-metadata; nothing actionable to branch on, just report and fall back
  } catch {
    logException(new Error("Failed to parse data-event-metadata attribute"), ["parseEventMetadataAttr error"]);
    return {};
  }
}
